<div class="base-modal">
  <span class="base-modal__close-button" (click)="closeModal()">
    <i class="material-icons"> close </i>
  </span>
  <div class="base-modal__header">
    <h2 class="base-modal__title">Facebook connection</h2>
  </div>
  <!-- ------------------------- New connection form ------------------------- -->
  <form [formGroup]="facebookForm" *ngIf="newConnection">
    <div class="base-modal__body" *ngIf="facebookAuthStatus === 'connected'">
      <brn-select
        formControlName="page"
        [options]="facebookPages"
        [suggest]="true"
        [theme]="'grey'"
        [optionLabel]="'name'"
        [placeholder]="'Select page...'"
      >
      </brn-select>
    </div>

    <div class="base-modal__footer">
      <button
        *ngIf="
          !facebookAuthStatus ||
          facebookAuthStatus === 'not_connected' ||
          facebookAuthStatus === 'pending'
        "
        class="button button--flat"
        (click)="getFacebookPages()"
      >
        Connect facebook page
        <i
          *ngIf="facebookAuthStatus === 'pending'"
          class="material-icons button__loader"
        >
          rotate_right
        </i>
      </button>

      <button
        *ngIf="facebookAuthStatus === 'connected'"
        class="button button--flat"
        (click)="createConnection()"
        [ngClass]="{ 'button--disabled': !validForm }"
      >
        Create connection
        <i *ngIf="pendingStatus" class="material-icons button__loader">
          rotate_right
        </i>
      </button>
    </div>
  </form>

  <!-- ------------------------- Exists connection form ------------------------- -->
  <form [formGroup]="facebookForm" *ngIf="!newConnection">
    <div class="base-modal__body">
      <div class="brn-form-field">
        <input
          *ngIf="!facebookAuthStatus"
          (click)="getFacebookPages()"
          type="text"
          readonly
          placeholder="Select page..."
          [value]="pageName"
        />
      </div>
      <brn-select
        *ngIf="facebookAuthStatus"
        formControlName="page"
        [options]="facebookPages"
        [suggest]="true"
        [theme]="'grey'"
        [optionLabel]="'name'"
        [placeholder]="'Select page...'"
      >
      </brn-select>
    </div>

    <div class="base-modal__footer">
      <button
        *ngIf="valueChanged"
        class="button button--flat"
        (click)="updateConnection()"
        [ngClass]="{ 'button--disabled': !validForm }"
      >
        Save changes
        <i *ngIf="pendingStatus" class="material-icons button__loader">
          rotate_right
        </i>
      </button>
      <button
        class="button button--flat button--danger"
        (click)="removeConnection()"
      >
        Remove connection
      </button>
    </div>
  </form>
</div>
